import { useRef, useState } from 'react';

import { ILottie } from '@lottielab/lottie-player';

import LottieAnimation from './Lottie';
import { Button } from './new-button';
import CopyAnimation from '@/assets/animations/Copy.json';

interface CopyProps {
  copyHandler: () => void;
  variant?: 'icon' | 'chip' | 'button';
  textSize?: 'xs' | 'sm' | 'md' | 'lg';
}

const Copy = ({ copyHandler, variant = 'chip', textSize = 'sm' }: CopyProps) => {
  const [copyClicked, setCopyClicked] = useState(false);
  const animationRef = useRef<ILottie>(null);
  const handleCopyClick = () => {
    setCopyClicked(true);
    copyHandler();
    setTimeout(() => {
      setCopyClicked(false);
      animationRef.current?.stop();
    }, 2000);
  };

  if (variant === 'icon') {
    return (
      <div onClick={handleCopyClick} className="h-4 w-4 hover:cursor-pointer">
        <LottieAnimation
          lottieRef={animationRef}
          playing={copyClicked}
          autoplay={copyClicked}
          animationData={CopyAnimation}
          loop={false}
          className="h-4 w-4"
        />
      </div>
    );
  }

  if (variant === 'button') {
    return (
      <Button variant="outline" className={`text-${textSize}`} size="sm" onClick={handleCopyClick}>
        <LottieAnimation
          lottieRef={animationRef}
          playing={copyClicked}
          autoplay={copyClicked}
          animationData={CopyAnimation}
          loop={false}
          className="h-3 w-3"
        />
        Copy
      </Button>
    );
  }

  return (
    <div
      onClick={handleCopyClick}
      className="flex items-center gap-2 rounded-full border px-3 py-2 hover:cursor-pointer hover:bg-gray-200"
    >
      <LottieAnimation
        lottieRef={animationRef}
        playing={copyClicked}
        autoplay={copyClicked}
        animationData={CopyAnimation}
        loop={false}
        className="h-4 w-4"
      />

      <span className={`text-xs transition-all duration-100 ease-in-out ${copyClicked ? 'w-10' : 'w-7'}`}>
        {copyClicked ? 'Copied!' : 'Copy'}
      </span>
    </div>
  );
};

export { Copy };
